<template>
  <update-business-member-field
    title="Phone"
    :member="member"
    :is-loading="isLoading"
    @update:isLoading="$emit('update:isLoading', $event)"
    :is-editing="isEditing"
    @update:isEditing="handleIsEditing"
    @save="save"
  >
    <base-phone-number-input placeholder="Enter phone number" v-model="phone" :e164.sync="phone164" required />
    <template #value>
      <base-phone-number-field :value="member.phone" v-if="member.phone" />
      <div v-else>-</div>
    </template>
  </update-business-member-field>
</template>

<script>
import UpdateBusinessMemberField from "@/views/business/member/components/UpdateBusinessMemberField";

export default {
  components: {
    UpdateBusinessMemberField,
  },
  props: {
    isLoading: Boolean,
    isEditing: Boolean,
    member: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      phone: "",
      phone164: "",
    };
  },
  methods: {
    handleIsEditing($event) {
      this.phone = this.member.phone;
      this.$emit("update:isEditing", $event);
    },
    save() {
      this.$emit("updated", {
        ...this.member,
        phone: this.phone164,
      });
    },
  },
};
</script>
